import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-activated",
  "use": "status-activated-usage",
  "viewBox": "0 0 58.34 58.34",
  "content": "<symbol viewBox=\"0 0 58.34 58.34\" id=\"status-activated\"><circle cx=\"29.17\" cy=\"29.17\" r=\"29.17\" /><path d=\"M40.15 16.19l-15 15.58-7-7.27-5 5.19 12 12.46 20-20.77z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/status-activated.svg
// module id = Mhr/
// module chunks = 1